const mm = {
  // ==================== CATALOG VIEW ====================
  'catalogs.title': 'Available Catalogs',
  'catalogs.subtitle': 'Select a catalog or create a purchase requisition directly',
  'catalogs.favorites': 'Favorites',
  'catalogs.favoritesSupplier': 'User-specific',
  'catalogs.favoritesDesc': 'Your personal favorite items and frequently ordered products',
  'catalogs.search': 'Search catalogs...',
  'catalogs.empty': 'No catalogs available',
  'catalogs.emptyDesc': 'No catalogs have been configured.',
  'catalogs.ociShop': 'OCI Shop',
  'catalogs.internalShop': 'Internal Catalog',
  'catalogs.products': 'Products',
  'catalogs.items': 'Items',
  'catalogs.mobileWarning': 'OCI catalogs work best on a desktop computer',
  'catalogs.filterAll': 'All',
  'catalogs.filterOci': 'OCI Shops',
  'catalogs.filterInternal': 'Internal Shops',
  'catalogs.filterFavorites': 'Favorites',
  'catalogs.filterKpis': 'Key figures',
  'kpi.title': 'Procurement KPIs',
  'kpi.valueYtd': 'Order value (YTD)',
  'kpi.valueMtd': 'Order value (month)',
  'kpi.count': 'Requests',
  'kpi.avg': 'Avg request value',
  'kpi.thisYear': 'current year',
  'kpi.thisMonth': 'current month',
  'kpi.perRequest': 'per request',
  'kpi.statusPending': 'open',
  'kpi.statusApproved': 'approved',
  'kpi.statusRejected': 'rejected',
  'kpi.trend12m': 'Order value — last 12 months',
  'kpi.topGroups': 'Top material groups',
  'kpi.topCostCenters': 'Top cost centers',
  'kpi.groupOther': 'Other',
  'kpi.noData': 'No data',
  'kpi.empty': 'No request data yet for KPIs.',
  'kpi.filterAll': 'All',
  'kpi.filterYear': 'Year',
  'kpi.filterStatus': 'Status',
  'kpi.filterEkgrp': 'Purchasing group',
  'kpi.filterMatkl': 'Material group',
  'kpi.filterKostl': 'Cost center',
  'kpi.filterAnforderer': 'Requester',
  'kpi.filterAbteilung': 'Department',
  'kpi.filterWerk': 'Plant',
  'kpi.filterMaterial': 'Material',
  'kpi.filterLieferant': 'Vendor',
  'kpi.filterBelegart': 'Document type',
  'kpi.filterKontierung': 'Account assignment',
  'kpi.reset': 'Reset',
  'kpi.moreFilters': 'More filters',
  'kpi.export': 'Excel export',
  'kpi.exporting': 'Exporting …',
  'kpi.selectAll': 'Select all',
  'kpi.clearAll': 'Clear all',
  'kpi.search': 'Search …',
  'catalogs.blankBanfTitle': 'Create blank PR',
  'catalogs.blankBanfDesc': 'Create a purchase requisition manually without catalog items',
  'catalogs.blankBanfBtn': 'Create PR',
  'catalogs.goToCart': 'Go to Cart',
  'catalogs.inCart': 'items',
  'catalogs.recentDrafts': 'Recent Drafts',
  'catalogs.noDrafts': 'No drafts available',
  'catalogs.positionsCount': '{count} items',
  'catalogs.buyingTip': 'Buying Tip',
  'catalogs.buyingTipText': 'Compare prices across multiple catalogs. Items with framework agreements or info records often offer better conditions than individual purchases.',
  'catalogs.statusDrafts': 'Open drafts',
  'catalogs.statusInCart': 'In cart',
  'catalogs.statusApproval': 'In approval',
  'catalogs.myDrafts': 'My drafts',
  'catalogs.subtotal': 'Subtotal',
  'catalogs.vat': 'VAT (19%)',
  'catalogs.grandTotal': 'Total amount',
  'catalogs.estimatedTotal': 'Estimated total',
  'catalogs.estimatedHint': 'Final price incl. tax is determined in the order.',
  'catalogs.help': 'Help & Support',
  'catalogs.helpDesc': 'Issues with ordering or catalog punch-out?',
  'catalogs.contactSupport': 'Contact support',
  'catalogs.openShop': 'Open shop',
  'catalogs.viewProducts': 'View products',
  'catalogs.openFavorites': 'Open favorites',
  'catalogs.ociModeActive': 'OCI catalog mode active',
  'catalogs.ociModeDesc': 'Direct SAP integration — items are transferred automatically',
  'catalogs.mobileWarningDetail': 'Many OCI shops block mobile embedding (X-Frame-Options). If you see a white screen, please open in browser.',
  'catalogs.footerPersonal': 'Personal selection',
  'catalogs.footerBrowser': 'Integrated browser',
  'catalogs.footerNewWindow': 'New window',
  'catalogs.footerInternal': 'Internal products',
  'catalogs.resetSearch': 'Reset search',

  // ==================== PRODUCT VIEW ====================
  'products.backToCatalogs': 'Back to Catalogs',
  'products.search': 'Search products...',
  'products.loading': 'Loading products...',
  'products.empty': 'No products found',
  'products.emptyDesc': 'Try a different search term.',
  'products.addToCart': 'Add to Cart',
  'products.inCart': 'In Cart',
  'products.filter': 'Filter',
  'products.filterReset': 'Reset',
  'products.filterMaterialType': 'Material Type',
  'products.filterStatus': 'Status',
  'products.status.active': 'Active',
  'products.status.blocked': 'Blocked',
  'products.status.discontinued': 'Discontinued',
  'products.filterCategory': 'Material group',
  'products.filterManufacturer': 'Manufacturer',
  'products.filterAttributes': 'Classification',
  'products.filterOf': 'of',
  'products.productsWord': 'products',
  'products.filterForTerm': 'for',
  // Sorting + pagination (F10)
  'products.sortLabel': 'Sort',
  'products.sortRelevance': 'Relevance',
  'products.sortNameAsc': 'Name A–Z',
  'products.sortNameDesc': 'Name Z–A',
  'products.sortPriceAsc': 'Price ascending',
  'products.sortPriceDesc': 'Price descending',
  'products.sortNewest': 'Newest first',
  'products.loadMore': 'Load more',
  'products.showingCount': 'Showing {shown} of {total}',
  'products.priceLabel': 'Price (EUR)',
  'products.priceFrom': 'from',
  'products.priceTo': 'to',
  'products.addFilter': '+ Filter',
  'products.filterFields': 'Filter fields',
  'products.filterGroupMasterdata': 'Master data',
  'products.filterActiveCount': '{count} active',
  'products.filterSavePrefs': 'Field selection saved',
  'products.supplierBy': 'by {supplier}',
  'products.aiTipTitle': 'AI Tip:',
  'products.aiTipText': 'Based on your needs, we recommend restocking consumables for the next quarter.',
  'products.imageAlt': 'Product image',
  'products.unnamedProduct': 'Unnamed product',
  'products.noDescriptionAvailable': 'No description available',
  'products.inStock': '{n} {unit} in stock',
  'products.resetSearch': 'Reset search',
  'products.sapInsights': 'SAP Insights',
  'products.totalStock': 'Total stock',
  'products.avgDeliveryTime': 'Avg. lead time',
  'products.activeContracts': 'Active contracts',

  // ==================== PRODUCT DETAIL ====================
  'productDetail.back': 'Back',
  'productDetail.notFound': 'Product not found.',
  'productDetail.profileTechnician': 'Technician',
  'productDetail.profileBuyer': 'Buyer',
  'productDetail.editButton': 'Edit',
  'productDetail.editTitle': 'Edit catalog product',
  'productDetail.editName': 'Name',
  'productDetail.editDescription': 'Description',
  'productDetail.editPrice': 'Price (EUR)',
  'productDetail.editSave': 'Save',
  'productDetail.editSaving': 'Saving…',
  'productDetail.editCancel': 'Cancel',
  'productDetail.editNameRequired': 'Name must not be empty.',
  'productDetail.editPriceInvalid': 'Price must be a number ≥ 0.',
  'productDetail.editError': 'Save failed.',
  'productDetail.sku': 'Article no.',
  'productDetail.sapMaterialNo': 'SAP material no.',
  'productDetail.manufacturer': 'Manufacturer',
  'productDetail.manufacturerPartNo': 'Manufacturer part no.',
  'productDetail.priceNet': 'Price (net)',
  'productDetail.addToCart': 'Add to cart',
  'productDetail.technicalData': 'Technical data',
  'productDetail.technicalEmpty': 'No technical attributes yet — coming later from SAP classification.',
  'productDetail.demoFromSap': 'Demo – later from SAP',
  'productDetail.procurement': 'Procurement',
  'productDetail.orderUnit': 'Order unit',
  'productDetail.preferredVendor': 'Preferred vendor',
  'productDetail.fixedVendor': 'Fixed vendor',
  'productDetail.purchasingOrg': 'Purchasing organization',
  'productDetail.purchasingGroup': 'Purchasing group',
  'productDetail.leadTime': 'Planned delivery time',
  'productDetail.minOrderQuantity': 'Minimum order quantity',
  'productDetail.infoRecord': 'Info record',
  'productDetail.framework': 'Framework agreement',
  'productDetail.validTo': 'valid until',
  'productDetail.priceScales': 'Price scales',
  'productDetail.fromQty': 'from',
  'productDetail.availability': 'Availability',
  'productDetail.availabilityEmpty': 'No stock recorded.',
  'productDetail.plant': 'Plant',
  'productDetail.storageLocation': 'Storage location',
  'productDetail.documents': 'Documents',
  'productDetail.download': 'Download',
  'productDetail.compliance': 'Compliance & certificates',
  'productDetail.aiAdvisor': 'AI purchasing advisor',
  'productDetail.aiAdvisorHint': 'Similar items under framework agreements may be cheaper. (Preview – no real logic yet.)',
  'productDetail.priceSource.contract': 'Contract price',
  'productDetail.priceSource.inforecord_plant': 'Info record (plant)',
  'productDetail.priceSource.inforecord_general': 'Info record (general)',
  'productDetail.priceSource.estimate': 'Estimate',
  'productDetail.priceSource.internal': 'Internal shop price',
  'productDetail.stockOwn': 'Own Stock',
  'productDetail.stockVendorConsignment': 'Vendor Consignment',
  'productDetail.stockAtVendor': 'Stock at Vendor',
  'productDetail.stockVendor': 'Vend.',
  'productDetail.sources': 'Sources',
  'productDetail.primarySource': 'Primary',
  'productDetail.vendorMaterialNo': 'Vendor material no.',
  'productDetail.deliveryTime': 'Delivery time (days)',
  'productDetail.minOrderQty': 'Min. order qty',
  'productDetail.incoterms': 'Incoterms',
  'productDetail.priceScalesFull': 'Price scales',
  'productDetail.scaleFrom': 'from {qty} {unit}',
  'productDetail.orderHistory': 'Order history',
  'productDetail.orderHistoryMore': '{count} more entries',
  'productDetail.noContract': 'No framework agreement on file',
  'productDetail.orderDate': 'Date',
  'productDetail.orderQty': 'Qty',
  'productDetail.orderPrice': 'Price',
  'productDetail.orderValue': 'Value',
  'productDetail.orderVendor': 'Vendor',

  // ==================== CART VIEW ====================
  'cart.title': 'Shopping Cart',
  'cart.items': 'Items',
  'cart.back': 'Back',
  'cart.selectAll': 'Select all',
  'cart.deselectAll': 'Deselect all',
  'cart.deleteCount': 'Delete {count}',
  'cart.selectedOf': '{selected} of {total} selected',
  'cart.empty': 'Your shopping cart is empty',
  'cart.emptyDesc': 'Add items from the available catalogs to start your order.',
  'cart.emptyBrowse': 'Browse Catalogs',
  'cart.removedItems': '{count} items removed from cart.',
  'cart.addedToFavorites': 'Item has been added to your favorites',
  'cart.loginForFavorites': 'You must be logged in to save favorites',
  'cart.errorSavingFavorite': 'Error saving favorite',
  'cart.headerTotal': 'Total',
  'cart.incomplete': 'Incomplete',
  'cart.editItem': 'Edit item',
  'cart.addToFavorites': 'Add to favorites',
  'cart.removeItem': 'Remove item',
  'cart.kontpiCostCenter': 'Cost Center',
  'cart.kontpiOrder': 'Order',
  'cart.detailsMaterial': 'Material & Item',
  'cart.detailsManufacturer': 'Manufacturer',
  'cart.detailsAccounting': 'Account Assignment',
  'cart.detailsPurchasing': 'Purchasing',
  'cart.detailsNotes': 'Notes',
  'cart.materialNumber': 'Material Number',
  'cart.productGroup': 'Product Group',
  'cart.supplier': 'Supplier',
  'cart.supplierArtNo': 'Supplier Art. No.',
  'cart.manufacturer': 'Manufacturer',
  'cart.manufacturerPartNo': 'Manufacturer Part No.',
  'cart.costCenter': 'Cost Center',
  'cart.glAccount': 'G/L Account',
  'cart.orderNumber': 'Order Number',
  'cart.wbsElement': 'WBS Element',
  'cart.assetNumber': 'Asset Number',
  'cart.networkNumber': 'Network Number',
  'cart.purchasingOrg': 'Purchasing Organization',
  'cart.purchasingGroup': 'Purchasing Group',
  'cart.plant': 'Plant',
  'cart.storageLocation': 'Storage Location',
  'cart.requester': 'Requester',
  'cart.longText': 'Long Text',
  'cart.changeQuantity': 'Change quantity:',
  'cart.quantityLabel': 'Quantity:',
  'cart.totalLabel': 'Total',
  'cart.removeLabel': 'Remove',
  'cart.summary': 'Summary',
  'cart.yourOrder': 'Your Order',
  'cart.articleCount': '{count} items in cart',
  'cart.selectedItems': 'Selected: {count} items',
  'cart.selectedTotal': 'Selected',
  'cart.totalAmount': 'Total Amount',
  'cart.ociTransfer': 'OCI Transfer',
  'cart.ociTransferDesc': 'Cart will be transferred to the calling system',
  'cart.ociTransferBtn': 'Transfer to SAP',
  'cart.ociTransferSelectedBtn': 'Transfer selected to SAP',
  'cart.createBanf': 'Create PR',
  'cart.createBanfDesc': 'Create purchase requisition from cart',
  'cart.createBanfBtn': 'Create PR',
  'cart.createBanfSelectedBtn': 'PR from Selection',
  'cart.estimatedTotal': 'Estimated price (total)',
  'cart.estimatedHint': 'Final price incl. tax will be determined in the purchase order.',
  'cart.applyKontierungAll': 'Apply account assignment to all items',
  'cart.kontForAll': 'Account assignment for all',
  'cart.kontForSelected': 'Account assignment for selection ({count})',
  'cart.kontierungAppliedAll': 'Account assignment applied to all items.',
  'cart.kontierungApplyError': 'Account assignment could not be applied.',
  'cart.kontModalTitle': 'Apply account assignment to all items',
  'cart.kontModalDesc': 'This account assignment will be applied to all {n} items in the cart. You can adjust it first. Empty fields are not overwritten.',
  'cart.kontType': 'Assignment category',
  'cart.kontCostCenter': 'Cost center',
  'cart.kontGlAccount': 'G/L account',
  'cart.kontPlant': 'Plant',
  'cart.kontApply': 'Apply to all',
  'cart.kontCancel': 'Cancel',
  'cart.syncDemo': 'last synchronized with SAP',
  'cart.approvalPath': 'Approval path (predicted)',
  'cart.aiCheckTitle': 'AI Check',
  'cart.aiCheckDesc': 'Items were automatically checked for plausibility. No anomalies found.',
  'cart.approvalDeptHead': 'Department Head',
  'cart.approvalFinance': 'Finance review pending',
  'cart.prefixMat': 'Mat.',
  'cart.prefixVendorNo': 'Vend. No.',
  'cart.fieldDeliveryDate': 'Del. date',
  'cart.fieldCostCenter': 'CC',
  'cart.fieldOrder': 'Order',
  'cart.fieldGlAccount': 'G/L Acc.',
  'cart.fieldPlant': 'Plant',
  'cart.fieldRequester': 'Requester',
  'cart.kontpiDefault': 'Default',
  'cart.collapseTitle': 'Collapse',
  'cart.detailsTitle': 'Details',
  'cart.missingCostCenter': 'Cost Center',
  'cart.missingSachkonto': 'G/L Account',
  'cart.missingOrder': 'Order',
  'cart.missingDeliveryDate': 'Delivery Date',
  'cart.missingPlant': 'Plant',
  'cart.noFurtherDetails': 'No further details available',
  'cart.ociModeActive': 'OCI mode active',
  'cart.ociNoApproval': 'Without approval process',
  'cart.ociHookMissing': 'Hook URL missing - check session',
  'cart.ociHookMissingTitle': 'Hook URL not available - session may have expired',
  'cart.ociUser': 'User:',
  'cart.ociSystem': 'System:',
  'cart.ociUserFallback': 'OCI User',
  'cart.kontCostCenterPlaceholder': 'e.g. 4711',
  'cart.kontGlAccountPlaceholder': 'e.g. 400000',
  'cart.kontPlantPlaceholder': 'e.g. 1000',

  // ==================== FAVORITES VIEW ====================
  'favorites.title': 'My Favorites',
  'favorites.count': '{count} saved items',
  'favorites.empty': 'No favorites yet',
  'favorites.emptyDesc': 'Add items from the catalogs to your favorites.',
  'favorites.addToCart': 'Add to Cart',
  'favorites.delete': 'Delete favorite',
  'favorites.deleteConfirm': 'Do you really want to delete this favorite?',
  'favorites.deleted': 'Favorite has been deleted.',
  'favorites.deleteError': 'Error deleting favorite',
  'favorites.search': 'Search favorites...',
  'favorites.loadError': 'Error loading favorites',
  'favorites.refresh': 'Refresh',
  'favorites.editFavorite': 'Edit favorite',
  'favorites.filterAll': 'All',
  'favorites.noMatch': 'No favorites match the filters.',
  'favorites.detMore': 'More details',
  'favorites.detLess': 'Less',
  'favorites.detDescription': 'Description',
  'favorites.detProductGroup': 'Product group',
  'favorites.detQuantity': 'Quantity',
  'favorites.detDeliveryDate': 'Delivery date',
  'favorites.detStorage': 'Storage location',
  'favorites.detManufacturerPartNo': 'Manufacturer no.',
  'favorites.detOrder': 'Order',
  'favorites.detRequester': 'Requester',
  'favorites.detPurchasingOrg': 'Purchasing org.',
  'favorites.detPurchasingGroup': 'Purchasing group',
  'favorites.typeKostenstelle': 'Cost Center',
  'favorites.typeAuftrag': 'Order',
  'favorites.typeMaterial': 'Material',
  'favorites.typeDienstleistung': 'Service',
  'favorites.typeDefault': 'Default',
  'favorites.sortRecent': 'Newest first',
  'favorites.sortNameAZ': 'Name (A–Z)',
  'favorites.sortPriceDesc': 'Price (descending)',
  'favorites.sortPriceAsc': 'Price (ascending)',
  'favorites.chipMat': 'Mat.',
  'favorites.chipVendorNo': 'Vend. No.',
  'favorites.chipKst': 'CC',
  'favorites.chipGlAccount': 'G/L Acc.',
  'favorites.chipPlant': 'Plant',
  'favorites.chipStorage': 'Storage',
  'favorites.chipProductGroup': 'PG',
  'favorites.chipQuantity': 'Qty',
  'favorites.chipRequester': 'Req.',

  // ==================== SAVED CARTS ====================
  'savedCarts.modal.title': 'Save cart',
  'savedCarts.modal.subtitle': '{count} items · {total} EUR',
  'savedCarts.modal.nameLabel': 'Name',
  'savedCarts.modal.namePlaceholder': 'e.g. Office supplies Q3, Screws assortment …',
  'savedCarts.modal.nameRequired': 'Please enter a name.',
  'savedCarts.modal.tagsLabel': 'Tags',
  'savedCarts.modal.tagsPlaceholder': 'e.g. Cleaning, Maintenance, Office',
  'savedCarts.modal.tagsHint': 'Separate multiple tags with commas',
  'savedCarts.modal.noteLabel': 'Note',
  'savedCarts.modal.notePlaceholder': 'Optional note …',
  'savedCarts.modal.templateLabel': 'Save as template',
  'savedCarts.modal.templateHint': 'Templates can be loaded with a single click.',
  'savedCarts.modal.saveBtn': 'Save',
  'savedCarts.modal.saving': 'Saving…',
  'savedCarts.saveCartBtn': 'Save cart',
  'savedCarts.saveSelectedBtn': 'Save selection ({count})',
  'savedCarts.panel.title': 'Saved carts',
  'savedCarts.panel.searchPlaceholder': 'Search by name, tags or note…',
  'savedCarts.panel.empty': 'No saved carts',
  'savedCarts.panel.emptyFiltered': 'No results',
  'savedCarts.panel.clearFilter': 'Clear filter',
  'savedCarts.panel.templateBadge': 'Template',
  'savedCarts.panel.priceCheckBadge': 'Check price',
  'savedCarts.panel.itemCount': '{count} items',
  'savedCarts.panel.loadReplace': 'Load (replace)',
  'savedCarts.panel.loadAppend': 'Append',
  'savedCarts.panel.renameBtn': 'Rename',
  'savedCarts.panel.deleteConfirm': 'Really delete "{name}"?',
  'savedCarts.loadSuccess': 'Cart loaded.',
  'savedCarts.loadError': 'Error loading saved cart.',
  'savedCarts.saveSuccess': 'Cart saved.',
  'savedCarts.saveError': 'Error saving cart.',
  'savedCarts.deleteSuccess': 'Saved cart deleted.',
  'savedCarts.deleteError': 'Error deleting cart.',
  'savedCarts.renameSuccess': 'Saved cart updated.',
  'savedCarts.renameError': 'Error updating cart.',

  // ==================== MISSING FIELDS MODAL ====================
  'missingFields.title': 'Missing Required Fields',
  'missingFields.subtitle': 'Please complete the missing information',
  'missingFields.titlePrepare': 'Complete Position',
  'missingFields.subtitlePrepare': 'Fill in required fields (*), adjust optional fields',
  'missingFields.article': 'Item:',
  'missingFields.unnamedFallback': 'Unnamed',
  'missingFields.requiredHint': 'Fields marked with * are required and must be filled in.',
  'missingFields.optionalHint': 'Optional fields — pre-filled from product data, editable at any time',
  'missingFields.optional': 'optional',
  'missingFields.costCenter': 'Cost Center *',
  'missingFields.costCenterLabel': 'Cost Center',
  'missingFields.purchasingOrg': 'Purchasing Organization *',
  'missingFields.purchasingOrgLabel': 'Purchasing Organization',
  'missingFields.plant': 'Plant *',
  'missingFields.plantLabel': 'Plant',
  'missingFields.searchCostCenter': 'Search for cost center...',
  'missingFields.searchPurchasingOrg': 'Search for purchasing organization...',
  'missingFields.searchPlant': 'Search for plant...',
  'missingFields.glAccount': 'G/L Account',
  'missingFields.searchGlAccount': 'Search for G/L account...',
  'missingFields.auftrag': 'Order',
  'missingFields.auftragPlaceholder': 'Search order number, e.g. 1151551',
  'missingFields.purchasingGroup': 'Purchasing Group',
  'missingFields.searchPurchasingGroup': 'Search for purchasing group...',
  'missingFields.kontierungstyp': 'Account Assignment Type',
  'kontierung.typKostenstelle': 'Cost Center',
  'kontierung.typAuftrag': 'Order',
  'kontierung.typMaterial': 'Material',
  'missingFields.preferredVendor': 'Preferred Vendor',
  'missingFields.preferredVendorPlaceholder': 'Name of preferred vendor',
  'missingFields.addToCart': 'Add to Cart',

  // ==================== OCI FRAME ====================
  'oci.title': 'OCI Catalog',
  'oci.loading': 'Loading OCI catalog...',
  'oci.error': 'Error loading OCI catalog',
  'oci.blocked': 'Pop-up blocked',
  'oci.blockedDesc': 'Please allow pop-ups for this page',
  'oci.mobileHint': 'For the best experience, use a desktop browser',
  'oci.close': 'Close catalog',
  'oci.openExternal': 'Open in new tab',
  'oci.transferring': 'Transferring items...',
  'oci.reloadTitle': 'Reload',
  'oci.fullscreenTitle': 'Fullscreen',
  'oci.showHeaderTitle': 'Show header',
  'oci.closeTitle': 'Close',
  'oci.frameTitle': 'OCI Catalog',

  // ==================== CREATE BANF VIEW ====================
  'banf.title': 'Create New Purchase Requisition',
  'banf.draftSaveFailed': 'Draft could not be saved — recent changes may not be stored.',
  'banf.draftDate': 'Draft from {date}',
  'banf.back': 'Back',
  'banf.addItem': 'Add Item',
  'banf.removeAll': 'Remove All',
  'banf.totalSum': 'Grand Total',
  'banf.docType': 'Document Type',
  'banf.docTypeNB': 'NB - Purchase Requisition',
  'banf.docTypeFO': 'FO - Outline Agreement Req.',
  'banf.docTypeRV': 'RV - Contract Requisition',
  'banf.clearList': 'Clear list',
  'banf.updating': 'Updating...',
  'banf.adding': 'Adding...',
  'banf.saveChanges': 'Save Changes',
  'banf.ociTransfer': 'Transfer OCI items to cart',
  'banf.transferToCart': 'Transfer to Cart',
  'banf.positionCopied': 'Position {position} has been copied.',
  'banf.allItemsRemoved': 'All items have been removed.',
  'banf.ociItemsLoaded': '{count} OCI items loaded successfully. Please check the account assignment details.',
  'banf.draftRestored': 'Saved draft has been restored.',
  'banf.addItemMin': 'Please add at least one item.',
  'banf.cartSuccess': '{count} PR items successfully added to cart!',
  'banf.cartPartialError': '{count} items could not be added.',
  'banf.cartError': 'Error adding to cart: ',
  'banf.updateNotFound': 'No item found to update.',
  'banf.updateSuccess': 'Item updated successfully!',
  'banf.updateAddedSuccess': 'Item updated and {count} new position(s) added!',
  'banf.updatePartialError': 'Item updated. {success} new position(s) added, {error} failed.',
  'banf.updateAddError': 'Item updated. New positions could not be added.',
  'banf.updateError': 'Error updating item: ',
  'banf.sessionExpired': 'Session expired: {error}',
  'banf.sessionExpiredDefault': 'Please log in again',
  'banf.unknownError': 'Unknown error',
  'banf.editSingleOnly': 'In edit mode, only one item can be edited.',
  'banf.favoriteUpdated': 'Favorite updated successfully!',
  'banf.favoriteUpdateError': 'Error updating favorite: ',
  'banf.positionLabel': 'Position {n}',
  'banf.positionError': 'Position {n}: {fields}',
  'banf.longtextTemplate': 'PR Position {pos} - Delivery date: {date}{group}{plant}{storage}',
  'banf.longtextGroup': ', Product group: {value}',
  'banf.longtextPlant': ', Plant: {value}',
  'banf.longtextStorage': ', Storage location: {value}',
  'banf.valFieldShortText': 'Short text',
  'banf.valFieldQuantity': 'Quantity',
  'banf.valFieldDeliveryDate': 'Delivery date',
  'banf.valFieldProductGroup': 'Product group',
  'banf.valFieldPrice': 'Estimated price',
  'banf.valFieldOrder': 'Order',
  'banf.valFieldPsp': 'WBS element',
  'banf.valFieldCostCenter': 'Cost center',
  'banf.valFieldGlAccount': 'G/L account',

  // ==================== BANF VALIDATION ====================
  'banf.val.shortTextRequired': 'Short text is a required field.',
  'banf.val.quantityRequired': 'A valid quantity is required.',
  'banf.val.deliveryDateRequired': 'Delivery date is a required field.',
  'banf.val.priceRequired': 'Estimated price is required and must be greater than 0.',
  'banf.val.orderRequired': 'Order is required for account assignment type "Order".',
  'banf.val.costCenterOrderRequired': 'Cost center is required for account assignment type "Order".',
  'banf.val.costCenterRequired': 'Cost center is required for account assignment type "Cost Center".',
  'banf.val.glAccountCostCenter': 'G/L account is required for account assignment type "Cost Center".',
  'banf.val.pspRequired': 'WBS element is required for account assignment type "WBS element".',
  'banf.val.glAccountRequired': 'G/L account is a required field.',
  'banf.val.missingFields': 'Missing required fields in {parts}',
  'banf.val.missingFieldsMulti': 'Missing required fields:\n{parts}',
  'banf.val.posShortText': 'Position {pos}: Short text is a required field.',
  'banf.val.posDeliveryDate': 'Position {pos}: Delivery date is a required field.',
  'banf.val.posPrice': 'Position {pos}: Estimated price is a required field.',

  // ==================== BANF ITEM CARD ====================
  'banf.item.copyPosition': 'Copy position',
  'banf.item.copy': 'Copy',
  'banf.item.removePosition': 'Remove position',
  'banf.item.remove': 'Remove',
  'banf.item.missingFields': 'Missing required fields: ',
  'banf.item.article': 'Item:',
  'banf.item.quantity': 'Quantity:',
  'banf.item.positionValue': 'Position value:',
  'banf.item.tabGeneral': 'General',
  'banf.item.tabLimits': 'Limits',
  'banf.item.tabServices': 'Services',
  'banf.item.tabSource': 'Source',
  'banf.item.tabTexts': 'Texts',
  'banf.item.tabAttachments': 'Attachments',
  'banf.item.naFallback': 'N/A',

  // ==================== BANF TYPE SELECTOR ====================
  'banf.type.costCenter': 'Cost Center',
  'banf.type.order': 'Order',
  'banf.type.material': 'Material',
  'banf.type.psp': 'WBS Element',
  'banf.general.psp': 'WBS Element',
  'banf.general.pspPlaceholder': 'Search project key (e.g. CUS250013)',

  // ==================== BANF GENERAL TAB ====================
  'banf.general.costCenterHiddenServicesAuftrag': 'Cost center and G/L account are controlled via the Limits fields, order and cost center are hidden due to services',
  'banf.general.costCenterHiddenServices': 'Cost center and G/L account are controlled via the Limits fields, cost center is hidden due to services',
  'banf.general.costCenterHiddenLimitsAuftrag': 'Order and cost center are hidden due to service items',
  'banf.general.costCenterHiddenLimits': 'Cost center is hidden due to service items',
  'banf.general.costCenterLimitsControlled': 'Cost center and G/L account are controlled via the Limits fields',
  'banf.general.kontierung': 'Account Assignment (Cost Center) *',
  'banf.general.searchCostCenter': 'Search for cost center...',
  'banf.general.order': 'Order *',
  'banf.general.orderPlaceholder': 'Search order number, e.g. 1151551',
  'banf.general.costCenter': 'Cost Center *',
  'banf.general.glAccount': 'G/L Account *',
  'banf.general.glAccountPlaceholder': 'e.g. 4100000',
  'banf.general.glAccountHint': 'G/L Account (6-8 digit number)',
  'banf.general.material': 'Material',
  'banf.general.materialPlaceholder': 'Material no. or code',
  'banf.general.shortText': 'Short Text *',
  'banf.general.shortTextPlaceholder': 'Description of the item',
  'banf.general.quantity': 'Quantity *',
  'banf.general.quantityFixed': 'Fixed to 1',
  'banf.general.unitOfMeasure': 'Unit of Measure',
  'banf.general.unitFixed': 'Fixed to LE',
  'banf.general.deliveryDate': 'Delivery Date *',
  'banf.general.productGroup': 'Product Group *',
  'banf.general.productGroupPlaceholder': 'e.g. IT Equipment',
  'banf.general.plant': 'Plant *',
  'banf.general.searchPlant': 'Search for plant...',
  'banf.general.storageLocation': 'Storage Location',
  'banf.general.storageLocationPlaceholder': 'e.g. 0001',
  'banf.general.priceUnit': 'Price Unit',
  'banf.general.priceUnitHint': 'Price refers to this quantity (e.g. 150.78 € per 1000). Default: 1.',
  'banf.general.preferredVendor': 'Preferred Vendor',
  'banf.general.preferredVendorPlaceholder': 'Name of preferred vendor',
  'banf.general.estimatedPrice': 'Estimated Price *',
  'banf.general.autoCalculated': 'Automatically calculated',
  'banf.general.expectedValueHint': 'Value from "Expected Value" (Limits tab)',
  'banf.general.plusServicePositions': '+ {count} service item',
  'banf.general.plusServicePositionsPlural': '+ {count} service items',
  'banf.general.servicePositions': '{count} service item',
  'banf.general.servicePositionsPlural': '{count} service items',
  'banf.general.sumFrom': 'Sum from ',
  'banf.general.requester': 'Requester',
  'banf.general.requesterPlaceholder': 'Name of the requester',
  'banf.general.purchasingGroup': 'Purchasing Group *',
  'banf.general.searchPurchasingGroup': 'Search for purchasing group...',
  'banf.general.purchasingOrg': 'Purchasing Organization',
  'banf.general.searchPurchasingOrg': 'Search for purchasing organization...',
  'banf.general.productCategories.administration': 'Administration',
  'banf.general.productCategories.sales': 'Sales',
  'banf.general.productCategories.production': 'Production',
  'banf.general.productCategories.it': 'IT Equipment',
  'banf.general.productCategories.office': 'Office Supplies',
  'banf.general.productCategories.maintenance': 'Maintenance & Repair',
  'banf.general.productCategories.cleaning': 'Cleaning',
  'banf.general.productCategories.security': 'Security',
  'banf.general.productCategories.automotive': 'Automotive',
  'banf.general.productCategories.electronics': 'Electronics',
  'banf.general.productCategories.other': 'Other',

  // ==================== BANF LIMITS TAB ====================
  'banf.limits.totalLimit': 'Total Limit',
  'banf.limits.totalLimitPlaceholder': 'Enter total limit',
  'banf.limits.expectedValue': 'Expected Value',
  'banf.limits.expectedValueHint': 'This value is used as "Estimated Price" in the General tab',
  'banf.limits.glAccount': 'G/L Account',
  'banf.limits.glAccountPlaceholder': 'Enter G/L account',
  'banf.limits.costCenter': 'Cost Center',
  'banf.limits.costCenterPlaceholder': 'Enter cost center',
  'banf.limits.order': 'Order *',
  'banf.limits.orderPlaceholder': 'Enter order number (required)',

  // ==================== BANF SERVICES TAB ====================
  'banf.services.title': 'Services',
  'banf.services.count': 'Services ({count})',
  'banf.services.copyExpanded': 'Copy expanded service',
  'banf.services.copy': 'Copy',
  'banf.services.addService': 'Add Service',
  'banf.services.empty': 'No services added yet',
  'banf.services.emptyHint': 'Click "Add Service" to get started',
  'banf.services.copySuffix': '(Copy)',

  // ==================== BANF SERVICE ITEM ====================
  'banf.service.defaultName': 'Service {index}',
  'banf.service.remove': 'Remove service',
  'banf.service.serviceNumber': 'Service Number',
  'banf.service.serviceNumberPlaceholder': 'Enter service number',
  'banf.service.shortText': 'Short Text',
  'banf.service.shortTextPlaceholder': 'Description of the service',
  'banf.service.quantity': 'Quantity',
  'banf.service.unitOfMeasure': 'Unit of Measure',
  'banf.service.grossPrice': 'Gross Price',
  'banf.service.currency': 'Currency',
  'banf.service.costCenter': 'Cost Center',
  'banf.service.costCenterPlaceholder': 'Enter cost center',
  'banf.service.glAccount': 'G/L Account',
  'banf.service.glAccountPlaceholder': 'Enter G/L account',
  'banf.service.order': 'Order *',
  'banf.service.orderPlaceholder': 'Enter order (required)',

  // ==================== BANF SOURCE TAB ====================
  'banf.source.contract': 'Contract',
  'banf.source.contractPlaceholder': 'Enter contract number',
  'banf.source.infoRecord': 'Info Record',
  'banf.source.infoRecordPlaceholder': 'Enter info record',
  'banf.source.supplierMatNo': 'Supplier Mat. No.',
  'banf.source.supplierMatNoPlaceholder': 'Enter supplier material number',
  'banf.source.preferredVendor': 'Preferred Vendor',
  'banf.source.preferredVendorPlaceholder': 'Name of preferred vendor',
  'banf.source.fixedVendor': 'Fixed Vendor',
  'banf.source.fixedVendorPlaceholder': 'Enter fixed vendor',
  'banf.source.assignSource': 'Assign Source',
  'banf.source.assignTitle': 'Select source of supply — active info records',
  'banf.source.assignLoading': 'Loading info records from SAP…',
  'banf.source.assignNoMaterial': 'Please select a material first ("General" tab) — info records belong to a material.',
  'banf.source.assignEmpty': 'No active info records found for this material.',
  'banf.source.assignUnavailable': 'The info-record value help is not yet available in the SAP adapter (Contract §7.4 point 15). Once it ships, the active info records will appear here automatically.',

  // ==================== BANF TEXTS TAB ====================
  'banf.texts.headerText': 'Header Text',
  'banf.texts.headerTextPlaceholder': 'Enter header text for the entire order...',
  'banf.texts.headerTextHint': 'General header text for the entire order',
  'banf.texts.itemText': 'Item Text',
  'banf.texts.itemTextPlaceholder': 'Enter additional information for the item...',
  'banf.texts.itemTextHint': 'Multi-line text for additional item information',

  // ==================== BANF RELEASE STRATEGY ====================
  'banf.release.title': 'Approval',
  'banf.release.strategy': 'Strategy',
  'banf.release.step': 'Step {seq}: {code} — {label}',
  'banf.release.pending': 'pending',
  'banf.release.demoNote': 'Multi-step approval will be executed later via SAP / n8n.',
  'banf.release.threshold': 'Value threshold',

  // ==================== BANF ATTACHMENTS TAB ====================
  'banf.attachments.upload': 'Upload Attachments',
  'banf.attachments.dropHere': 'Drop files here',
  'banf.attachments.dragHere': 'Drag files here',
  'banf.attachments.selectFiles': 'Select Files',
  'banf.attachments.maxSize': 'Maximum file size: 10 MB per file',
  'banf.attachments.tooLarge': '"{name}" exceeds 10 MB and was not added.',
  'banf.attachments.readError': '"{name}" could not be read.',
  'banf.attachments.reading': 'Reading files …',
  'banf.attachments.metaOnly': 'Content not stored — please re-attach',
  'banf.attachments.uploaded': 'Uploaded Files ({count})',
  'banf.attachments.download': 'Download file',
  'banf.attachments.remove': 'Remove file',

  // ==================== PURCHASE REQUESTS VIEW ====================
  'pr.title': 'Purchase Requests',
  'pr.statusPending': 'Pending',
  'pr.statusApproved': 'Approved',
  'pr.sapPosted': 'In SAP',
  'pr.sapFailed': 'SAP transfer failed',
  'pr.sapRetry': 'Retry transfer',
  'pr.sapRetryError': 'SAP transfer retry failed',
  'pr.statusRejected': 'Rejected',
  'pr.statusTransferred': 'Transferred to SAP',
  'pr.filterAll': 'All',
  'pr.filterPending': 'Pending',
  'pr.filterApproved': 'Approved',
  'pr.filterRejected': 'Rejected',
  'pr.filterTransferred': 'Transferred',
  'pr.drafts': 'Drafts',
  'pr.draftFrom': 'Draft from {date}',
  'pr.draftItems': '{count} items',
  'pr.draftResume': 'Resume',
  'pr.draftDelete': 'Delete',
  'pr.empty': 'No purchase requests available',
  'pr.emptyFiltered': 'No requests with this status',
  'pr.approve': 'Approve',
  'pr.reject': 'Reject',
  'pr.transfer': 'Transfer to SAP',
  'pr.detail.requester': 'Requester',
  'pr.detail.department': 'Department',
  'pr.detail.costCenter': 'Cost Center',
  'pr.detail.date': 'Date',
  'pr.detail.items': 'Items',
  'pr.detail.total': 'Total Value',
  'pr.detail.comment': 'Comment',
  'pr.detail.approvedBy': 'Approved by',
  'pr.detail.rejectedBy': 'Rejected by',
  'pr.detail.reason': 'Reason',
  'pr.commentPlaceholder': 'Enter comment (optional)...',
  'pr.rejectReasonPlaceholder': 'Reason for rejection...',
  'pr.loadError': 'Error loading purchase requests',
  'pr.draftDeleteConfirm': 'Do you really want to delete this draft?',
  'pr.draftDeleted': 'Draft has been deleted',
  'pr.deleteDraft': 'Delete draft',
  'pr.deleteRequest': 'Delete',
  'pr.sapTransferFailedShort': 'SAP transfer failed (details on the SAP badge, retry available)',
  'pr.draftDeleteError': 'Error deleting draft',
  'pr.approveConfirm': 'Are you sure you want to approve this purchase request?',
  'pr.rejectConfirm': 'Are you sure you want to reject this purchase request?',
  'pr.requestApproved': 'Purchase request has been approved!',
  'pr.requestRejected': 'Purchase request has been rejected!',
  'pr.processError': 'Error processing purchase request: {error}',
  'pr.deleteConfirm': 'Are you sure you want to permanently delete purchase request #{id} from "{name}"?\n\nThis action cannot be undone!',
  'pr.requestDeleted': 'Purchase request #{id} has been deleted successfully!',
  'pr.deleteError': 'Error deleting purchase request: {error}',
  'pr.loadingRequests': 'Loading purchase requests...',
  'pr.draftEmptyDesc': 'When you leave the PR view, your changes will be automatically saved as a draft.',
  'pr.draftDefaultTitle': 'Draft #{id}',
  'pr.draftLabel': 'Draft',
  'pr.positions': 'Items',
  'pr.totalValue': 'Total Value',
  'pr.lastModified': 'Last Modified',
  'pr.hideDetails': 'Hide',
  'pr.showDetails': 'Show Details',
  'pr.otherCostCenter': 'Different Cost Center',
  'pr.itemArticleNo': 'Article No.:',
  'pr.itemMaterialNo': 'Material No.:',
  'pr.itemSupplier': 'Supplier:',
  'pr.itemUnit': 'Unit:',
  'pr.itemMatkl': 'Material group:',
  'pr.itemPlant': 'Plant:',
  'pr.itemLgort': 'Storage location:',
  'pr.itemKontierung': 'Account assignment:',
  'pr.itemKostl': 'Cost center:',
  'pr.itemSakto': 'G/L account:',
  'pr.itemAuftrag': 'Order:',
  'pr.itemPsp': 'WBS element:',
  'pr.itemDeliveryDate': 'Delivery date:',
  'pr.itemEkgrp': 'Purchasing group:',
  'pr.itemPeinh': 'Price unit:',
  'pr.itemFixedVendor': 'Fixed vendor:',
  'pr.reorder': 'Create again',
  'pr.reorderConfirm': 'Copy the items of PR #{id} into a new PR? They will be loaded into the "Create new PR" form where you can adjust them (delivery date is reset).',
  'pr.commentOptional': 'Comment (optional)',
  'pr.editHistory': 'Edit History',
  'pr.statusHistory': 'Status History',
  'pr.processedAt': 'Processed on:',
  'pr.statusApprovedFull': '✅ Approved',
  'pr.statusRejectedFull': '❌ Rejected',
  'pr.statusTransferredFull': '📦 Transferred to SAP',
  'pr.statusPendingFull': '⏳ Pending',
  'pr.supervisorComment': 'Supervisor\'s comment:',

  // --- PR list redesign (bl.*) — design handoff 28.07. ---
  'bl.title': 'PR Requests',
  'bl.subtitle': 'Review, approve and transfer purchase requisitions to SAP.',
  'bl.kpiAwaiting': 'Awaiting your approval',
  'bl.kpiRequests': 'requests',
  'bl.kpiLeadTime': 'Ø lead time',
  'bl.kpiDays': 'days (creation → decision)',
  'bl.kpiNoData': 'no data yet',
  'bl.kpiVolume': 'Total volume',
  'bl.kpiPosted': 'Transferred to SAP',
  'bl.kpiDocs': 'documents',
  'bl.kpiErrors': 'errors',
  'bl.tabAll': 'All',
  'bl.tabDrafts': 'Drafts',
  'bl.stPending': 'Pending',
  'bl.stApproved': 'Approved',
  'bl.stTransferred': 'Transferred',
  'bl.stRejected': 'Rejected',
  'bl.stDraft': 'Draft',
  'bl.selectAllPending': 'Select all {n} pending',
  'bl.searchPlaceholder': 'Search PR, subject, vendor or SAP document …',
  'bl.comfortable': 'Comfortable',
  'bl.compact': 'Compact',
  'bl.columns': 'Columns',
  'bl.export': 'Export',
  'bl.exportError': 'Export failed',
  'bl.resetFilters': 'Reset filters',
  'bl.empty': 'No PRs found',
  'bl.colBanf': 'PR / Subject',
  'bl.colStatus': 'Status',
  'bl.colAmount': 'Amount',
  'bl.colDept': 'Department',
  'bl.colAnforderer': 'Requester',
  'bl.colKostl': 'Cost center',
  'bl.colMatkl': 'Material group',
  'bl.colLieferant': 'Vendor',
  'bl.colBelegart': 'Doc. type',
  'bl.colErstellt': 'Created',
  'bl.colSap': 'SAP document',
  'bl.colAction': 'Action',
  'bl.waitingApproval': 'awaiting approval',
  'bl.waiting': 'waiting',
  'bl.draftSub': 'Draft · not submitted yet',
  'bl.position': 'item',
  'bl.positions': 'items',
  'bl.net': 'net',
  'bl.approvalPath': 'Approval path',
  'bl.stepCreated': 'Created',
  'bl.stepApproval': 'Approval',
  'bl.stepRejected': 'Rejected',
  'bl.stepSap': 'SAP transfer',
  'bl.sapOpen': 'follows after approval',
  'bl.sapFailed': 'transfer failed',
  'bl.retryStarted': 'SAP transfer restarted',
  'bl.details': 'Details',
  'bl.edit': 'Edit',
  'bl.showDetails': 'Show details',
  'bl.copySap': 'Copy SAP document',
  'bl.selected': 'selected',
  'bl.clearSelection': 'Clear',
  'bl.bulkApproveBtn': 'approve',
  'bl.bulkNonePending': 'No pending PRs in the selection — approve/reject only affects pending ones.',
  'bl.bulkApproveConfirm': 'Approve {n} pending PR requests? Each approved request is transferred to SAP.',
  'bl.bulkRejectConfirm': 'Reject {n} pending PR requests?',
  'bl.bulkApproved': 'approved',
  'bl.bulkRejected': 'rejected',
  'bl.bulkSkipped': 'skipped (not pending)',
  'bl.bulkFailed': 'failed',
  'bl.approvedToast': 'approved',
  'bl.rejectedToast': 'rejected',
  'bl.metaCreated': 'Created',
  'bl.metaDeptKst': 'Department / CC',
  'bl.sapFailedPill': 'SAP error',
  'bl.stDeleted': 'Deleted',
  'bl.loadFailed': 'Could not load PR requests.',
  'bl.retry': 'Retry',
  'bl.bulkTooMany': 'Maximum 25 PRs per bulk action — each approval triggers an SAP posting. Please reduce the selection.',
  'bl.tabSapFailed': 'SAP errors',
};

export default mm;
